export default "__VITE_ASSET__CfLM$vyg__"